// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__2qyYZ","Icon":"Languages_Icon__3nd-E","LanguagesSelect":"Languages_LanguagesSelect__vijtj","minimalist":"Languages_minimalist__1CqFe"};